<template>
    <edit-chat-connect-system-goal-form :system-goal-id="props.systemGoal" />
</template>

<script setup lang="ts">
    import EditChatConnectSystemGoalForm from '@/ai/assistent/components/forms/chat-connect/EditChatConnectSystemGoalForm.vue';

    const props = defineProps<{ systemGoal: string, assistentId: string }>();
</script>
